import { fetchDataV2 } from "./utils";

// Matches cedar-backend's VideoSchema (routes/video.py, schemas/video.py, feat-2/cedar-restructure) -
// no playback_url here, only on VideoPlayback below, so this stays cacheable server-side.
export interface VideoMeta {
  id: number;
  video_type: string;
  file_name: string;
  content_type?: string | null;
  size_bytes?: number | null;
  uploaded_at: string;
}

// Matches VideoPlaybackSchema - VideoMeta plus a short-lived (backend-side TTL, ~1hr) signed GCS
// URL. Never persist this beyond the current session/page load - it expires.
export interface VideoPlayback extends VideoMeta {
  playback_url: string;
  expires_at: string;
}

// VideoType members on the backend (constants/custom_types.py) - the keys GET /video's map is
// keyed by for each specific video.
export const QUICK_TOUR_VIDEO_TYPE = "quick_tour";
export const GOOGLE_ACCOUNT_CONNECT_VIDEO_TYPE = "google_account_connect";

// GET /video - VideoMapSchema: the latest video per type, keyed by VideoType value. A type with no
// uploaded video is simply absent from the map (not present-and-null), per the backend's own
// docstring - callers should use `?.[type]` rather than assuming every type is a key.
export const getVideos = (): Promise<Record<string, VideoMeta>> => fetchDataV2("/video");

// GET /video/{video_id} - VideoPlaybackSchema: metadata plus this specific video's own signed
// playback_url, fetched separately from getVideos() so that cacheable map stays URL-free.
export const getVideoPlayback = (videoId: number): Promise<VideoPlayback> => fetchDataV2(`/video/${videoId}`);
